/**************************************************
 * Nombre:       Home_Buena_Educacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_buena.png'
import {NEGRITA} from "../../../Constantes";
import {WhatsApp} from '@mui/icons-material'

const Home_Buena_Educacion = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: 'url(' + fondo + ')',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            color: '#fff',
                            py: 12
                        }}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{
                                fontFamily: NEGRITA,
                                fontSize: 48,
                                fontWeight: 600,
                                textAlign: 'center',
                                lineHeight: 1.1
                            }}>Una
                                buena educación es
                                la base de un mejor futuro</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center', mt: 2}}>
                            <Typography sx={{fontSize: 20, fontWeight: 400, textAlign: 'center', lineHeight: 1.1}}>
                                En CESSA, impulsamos tu creatividad y pensamiento crítico para que construyas una
                                carrera con propósito. Te brindamos una formación técnica de alta calidad, diseñada para
                                conectarte rápidamente con las oportunidades del mundo laboral y asegurar tu éxito
                                profesional
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 6}}>
                            <Button startIcon={<WhatsApp/>} color={'secondary'}>Hablar con un asesor</Button>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Buena_Educacion  